import environment from '@environment';
import { PaymentStatusDTO } from 'core/models/account/make-payment-payload.dto';
import { EndpointHelper } from 'core/services/endpoint.helper';
import { HttpClient } from 'core/services/http';
import { PaymentService } from 'core/stores/payment/interfaces/payment-service';
import { RequestRapydCheckout } from 'core/stores/payment/interfaces/request-rapyd-checkout';

export interface RapydEmbeddedResponse {
  id: string;
  redirect_url: string;
}

export class RapydPaymentService implements PaymentService<RequestRapydCheckout> {
  public canStatusPoll = false;
  public canRefetchPoll = false;
  public canTimeoutPoll = false;

  //TODO: This api does not exist
  private static apiBuilder = new EndpointHelper(`${environment.UMBRACO_API_URI}`);
  private apiBuilder = new EndpointHelper(`${environment.UMBRACO_API_URI}`);

  static requestPayment(requestBody: RequestRapydCheckout) {
    const url = this.apiBuilder.createUrl('payment').addRouteParam('checkout').build();

    return HttpClient.GetInstance.post<unknown, any>(url, requestBody).then((res) => res.data);
  }

  MakePayment(request?: Partial<RequestRapydCheckout>) {
    const url = this.apiBuilder.createUrl('payment').addRouteParam('checkout').build();

    return HttpClient.GetInstance.post<unknown, RapydEmbeddedResponse>(url, request).then((res) => res.data);
  }

  PaymentStatus(country: string, transactionId: string): Promise<PaymentStatusDTO> {
    return Promise.reject(`RapydPaymentService -> PaymentStatus not implemented`);
  }

  RefetchPayment() {
    return Promise.reject('RapydPaymentService -> RefetchPayment Not Implemented')
  }

  TokenLinks(req?: Partial<RequestRapydCheckout>) {
    return Promise.reject(`RapydPaymentService -> TokenLinks not implemented`);
  }
}